// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"114":"core","453":"operations"}[chunkId] || chunkId) + "." + {"114":"d144fe83","406":"55c47387","453":"0b3d8123"}[chunkId] + ".chunk.css";
};